import React, { useState } from 'react';
import { Store } from '../../store';
import { Box, Text } from '@chakra-ui/react';
import { EmailCollection } from './EmailCollection';
import { AnimatePresence } from 'framer-motion';
import { MotionBox } from '../Motion';
import { NameCollection } from './NameCollection';
import { getIntroField } from '../../utils';
import { useSessionInfo } from '@outdoorly/react-chat-sdk';

export const IntroPIICollection: React.FC<{
  submitEmail: (email: string) => void;
  emailSubmission?: { censored?: string; completed?: boolean };
  emailSkipped?: boolean;
  submitName: (name: string) => void;
  skipName: () => void;
  skipEmail: () => void;
}> = (props) => {
  const { submitEmail, emailSubmission, emailSkipped, skipName, submitName, skipEmail } = props;
  const { sessionInfo } = useSessionInfo();

  const [step, setStep] = useState(
    getIntroField('remarkIntroMessageName') ||
      getIntroField('remarkIntroMessageNameSkipped') ||
      sessionInfo?.name
      ? 2
      : 1
  );

  const firstName = getIntroField('remarkIntroMessageName') || sessionInfo?.name;
  const labels = Store.useState((s) => s.labels).substitute({
    firstName
  });

  return (
    <Box>
      <AnimatePresence>
        {step === 1 && (
          <MotionBox initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <NameCollection
              submitName={(name) => {
                submitName(name);
                setStep(2);
              }}
              skipName={() => {
                skipName();
                setStep(2);
              }}
            />
          </MotionBox>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {step === 2 && (
          <MotionBox initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <EmailCollection
              submitEmail={submitEmail}
              skipEmail={skipEmail}
              emailSkipped={emailSkipped}
              emailSubmission={emailSubmission}
              emailPrompt={firstName ? labels.whatsYourEmailWithName : labels.whatsYourEmailWithoutName}
              submitLabel={labels.emailSubmissionIntro}
              includeCount={!sessionInfo?.name}
            />
          </MotionBox>
        )}
      </AnimatePresence>
    </Box>
  );
};
